import { useContext, PropsWithChildren, useRef, useLayoutEffect } from 'react';
import { Context } from './context';
import { Text } from '@components';
import styles from './Timeline.module.scss';
import { Orb } from './Orb';

type TProps = {
	date: string;
	icon: JSX.Element;
	backgroundColor?: string;
	isLast?: boolean;
	dateColor?: string;
	noDate?: boolean;
	lineColor?: string;
}

export const Item = (props: PropsWithChildren<TProps>) => {
	const {
		date,
		dateColor,
		icon,
		backgroundColor,
		isLast = false,
		noDate = false,
		lineColor,
		children
	} = props;
	const dateTextRef = useRef<HTMLDivElement>(null);
	const { dir, verticalDateWidth, setVerticalDateWidth } = useContext(Context);
	useLayoutEffect(() => {
		if (dateTextRef && dateTextRef.current) {
			const { width } = dateTextRef.current.getBoundingClientRect();
			if (width > verticalDateWidth) setVerticalDateWidth(width);
		}
	}, []);
	return <div className={dir === 'vertical' ? styles.containerRow : styles.containerColumn}>
		{dir === 'vertical' && date && <div className={styles.matchOrbHeight} ref={dateTextRef} style={{ width: verticalDateWidth === 0 ? 'auto' : `${verticalDateWidth}px` }}><Text>{date}</Text></div>}
		{dir === 'vertical' && (
			<Orb
				icon={icon}
				backgroundColor={backgroundColor}
				isLast={isLast}
				noInlinePadding={noDate}
				lineColor={lineColor}
			/>
		)}
		{children}
		{dir === 'horizontal' && <Orb icon={icon} backgroundColor={backgroundColor} isLast={isLast} />}
		{dir === 'horizontal' && <Text color={dateColor ?? 'var(--neutral-07)'}>{date}</Text>}
	</div>
}
